/**
 * Service Initializer
 * This file ensures that all required service methods are properly attached and available
 */

import boxService from './boxService';
import offlineApi from './offlineApi';

/**
 * Ensure the checkOfflineData function is properly attached to boxService
 * This fixes the "boxService.checkOfflineData is not a function" runtime error
 */
const ensureOfflineFunctions = () => {
  // Define a fallback implementation if the function is missing
  const checkOfflineDataFallback = async () => {
    try {
      console.log('[Service Initializer] Using fallback checkOfflineData implementation');
      
      // Call the underlying offlineApi methods directly
      const offlineModeEnabled = await offlineApi.isOfflineModeEnabled();
      console.log(`Offline mode enabled: ${offlineModeEnabled}`);
      
      if (!navigator.onLine || offlineModeEnabled) {
        console.log('Device is offline or offline mode is enabled - prefetching data...');
        await offlineApi.prefetchEssentialData();
        return true;
      }
      
      return false;
    } catch (error) {
      console.error('[Service Initializer] Error in fallback checkOfflineData:', error);
      return false;
    }
  };

  // Check if the function exists and is a function
  if (typeof boxService.checkOfflineData !== 'function') {
    console.warn('[Service Initializer] boxService.checkOfflineData is not a function - adding fallback implementation');
    boxService.checkOfflineData = checkOfflineDataFallback;
  }
  
  // Return the initialized service for convenience
  return boxService;
};

// Perform initialization immediately
ensureOfflineFunctions();

// Export for explicit initialization in other modules if needed
export { ensureOfflineFunctions };
